import { BenefitDTOBenefitEnum, DocumentsDTO } from 'probonio-shared-ui/api';
import { BenefitMenuItemInterface } from '../../module/benefits/nav/BenefitMenuItem';
import { BenefitNavigationExtensionInterface } from '../interface/benefit-navigation.extension.interface';

export class BikeleasingBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ documents }: { documents?: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.Bikeleasing.toLowerCase();

    return [
      { title: 'subPage.employees', to: `/benefits/${benefit}` },
      { title: 'benefitsModule:BIKELEASING.integration.title', to: '/benefits/bikeleasing/integration' },
      { title: 'benefitsModule:BIKELEASING.contracts', to: '/benefits/bikeleasing/contracts' },
      ...(documents?.totalCount ? [{ title: 'subPage.documents', to: `/benefits/${benefit}/documents` }] : []),
    ];
  }
}
